var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 152,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 144 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-4, .cls-8, .cls-9, .cls-14, .cls-19, .cls-23, .cls-43, .cls-48, .cls-49, .cls-57, .cls-59, .cls-62 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-67 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-68 {\n        isolation: isolate;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-14 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-17 {\n        fill: none;\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-19 {\n        fill: url(#radial-gradient-11);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-69 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-23 {\n        fill: url(#radial-gradient-8);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-70 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-43 {\n        fill: url(#radial-gradient-9);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-48 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-49 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-57 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-59 {\n        fill: url(#radial-gradient-12);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-62 {\n        fill: url(#radial-gradient-10);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-37);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -11.65,
    y1: 47.42,
    x2: 103.31,
    y2: -67.54,
    gradientTransform: "translate(15.88 91.78) rotate(8.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c460ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#be5eac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#af59ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#9651ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7446ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583ead"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 28.58,
    y1: -28.4,
    x2: 82.26,
    y2: 25.29,
    gradientTransform: "translate(15.88 91.78) rotate(8.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#a6caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#a59ce1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a581d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -40.71,
    y1: 84.38,
    x2: 51.52,
    y2: -7.85,
    gradientTransform: "translate(15.88 91.78) rotate(8.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9381d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9a9ce1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a6caff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 132.88,
    y1: 28.15,
    x2: 61.83,
    y2: -42.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -11.65,
    y1: 47.42,
    x2: 103.31,
    y2: -67.54,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 4756.03,
    cy: 50.36,
    fx: 4756.03,
    fy: 50.36,
    r: 21.86,
    gradientTransform: "translate(-528.42 -46.04) rotate(8.11) scale(.13 1.51) skewX(-.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#502585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#704d9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#9b83b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#bfafd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#dad2e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#eeeaf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#faf9fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 4858.62,
    cy: 48.9,
    fx: 4858.62,
    fy: 48.9,
    r: 21.86,
    gradientTransform: "translate(166.8 -520.85) rotate(89.96) scale(.13 1.49) skewX(-.48)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 4419.5,
    cy: 48.34,
    fx: 4419.5,
    fy: 48.34,
    r: 21.86,
    gradientTransform: "translate(-528.69 -44.13) rotate(8.11) scale(.13 1.44) skewX(-.46)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 4491.82,
    cy: 48.18,
    fx: 4491.82,
    fy: 48.18,
    r: 21.86,
    gradientTransform: "translate(-528.74 -43.16) rotate(8.11) scale(.13 1.49) skewX(-.48)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 33.27,
    y1: 58.74,
    x2: 81.21,
    y2: 10.8,
    gradientTransform: "translate(15.88 91.78) rotate(8.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#a6caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#7b78e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5530d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4715d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -11.85,
    y1: 53.5,
    x2: 34.61,
    y2: 7.03,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "91.84 68.1 120.71 87.07 62.48 86.77 33.6 67.81 91.84 68.1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -323.18,
    cy: 81.1,
    fx: -295.22,
    fy: 60.08,
    r: 34.98,
    gradientTransform: "translate(653.29 27.98) scale(1.89 .5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#502585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9c84ba",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -23.13,
    y1: 257.53,
    x2: 100.33,
    y2: 134.08,
    gradientTransform: "translate(-23.7 -128.26) rotate(-11.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#a6caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9a9ce1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9381d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 42.16,
    y1: 170.31,
    x2: 73.87,
    y2: 202.01,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -6.5,
    y1: 221.5,
    x2: 29.95,
    y2: 185.04,
    gradientTransform: "translate(-23.7 -128.26) rotate(-11.77)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "17.15 45.47 20.11 59.83 56.23 68.45 53.26 54.08 17.15 45.47"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 4347.25,
    cy: 170.42,
    fx: 4347.25,
    fy: 170.42,
    r: 21.86,
    gradientTransform: "translate(-581.67 -70.72) rotate(-11.77) scale(.13 1.49) skewX(.15)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 4434.76,
    cy: 171.26,
    fx: 4434.76,
    fy: 171.26,
    r: 21.86,
    gradientTransform: "translate(-581.67 -70.72) rotate(-11.77) scale(.13 1.49) skewX(.15)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "112.2 33.11 115.16 47.48 56.23 68.45 53.26 54.08 112.2 33.11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 4706.8,
    cy: 172.61,
    fx: 4706.8,
    fy: 172.61,
    r: 21.86,
    gradientTransform: "translate(-581.67 -70.72) rotate(-11.77) scale(.13 1.49) skewX(.15)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 4809.53,
    cy: 172.28,
    fx: 4809.53,
    fy: 172.28,
    r: 21.86,
    gradientTransform: "translate(-581.67 -70.72) rotate(-11.77) scale(.13 1.49) skewX(.15)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -15.45,
    y1: 228.69,
    x2: 31.02,
    y2: 182.23,
    gradientTransform: "translate(-23.7 -128.26) rotate(-11.77)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 26.33,
    y1: 239.57,
    x2: 74.26,
    y2: 191.64,
    gradientTransform: "translate(-23.7 -128.26) rotate(-11.77)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 23.01,
    y1: 151.8,
    x2: 54.11,
    y2: 182.9,
    gradientTransform: "translate(-23.7 -128.26) rotate(-11.77)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 107.36,
    y1: 169.78,
    x2: 20.22,
    y2: 186.97,
    gradientTransform: "translate(-23.7 -128.26) rotate(-11.77)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 57.43,
    y1: 176.4,
    x2: 83.92,
    y2: 154.57,
    gradientTransform: "translate(-23.7 -128.26) rotate(-11.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a11ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4722c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6445ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a11ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 89.89,
    y1: 156.95,
    x2: 60.25,
    y2: 186.59,
    gradientTransform: "translate(-23.7 -128.26) rotate(-11.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#614fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5330e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4715d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#491ad4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5029e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5b42f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#614fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#5330e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#4715d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#491ad4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5029e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#5b42f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#614fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -59.14,
    y1: 397.14,
    x2: -32.67,
    y2: 375.33,
    gradientTransform: "translate(-98.05 -335.16) rotate(-32.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#280c75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#341790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#5234d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6445ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d0e85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -26.69,
    y1: 377.71,
    x2: -56.32,
    y2: 407.34,
    gradientTransform: "translate(-98.05 -335.16) rotate(-32.25)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -1387.09,
    y1: 177.28,
    x2: -1360.59,
    y2: 155.44,
    gradientTransform: "translate(-1336.09 144.22) rotate(168.23) scale(1 -1)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1354.62,
    y1: 157.81,
    x2: -1384.28,
    y2: 187.47,
    gradientTransform: "translate(-1336.09 144.22) rotate(168.23) scale(1 -1)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -1421.2,
    y1: -94.34,
    x2: -1394.71,
    y2: -116.17,
    gradientTransform: "translate(-1357.54 -98.57) rotate(-170.9) scale(1 -1)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -1388.74,
    y1: -113.8,
    x2: -1418.39,
    y2: -84.15,
    gradientTransform: "translate(-1357.54 -98.57) rotate(-170.9) scale(1 -1)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 2139.99,
    cy: 1126.13,
    fx: 2139.99,
    fy: 1126.13,
    r: 68.9,
    gradientTransform: "translate(-574.35 -149.75) rotate(-.02) scale(.3 .17) skewX(.01)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -1443.01,
    y1: 47.23,
    x2: -1426.86,
    y2: 33.93,
    gradientTransform: "translate(-1382.38 33.76) rotate(178.32) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#240a6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#301586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4e31cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6445ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a0c7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -90.08,
    y1: -370.52,
    x2: -61.82,
    y2: -370.39,
    gradientTransform: "translate(-98.12 382.72) rotate(35.34)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -718.03,
    y1: 706.19,
    x2: -701.88,
    y2: 692.89,
    gradientTransform: "translate(-581.65 783.25) rotate(86.35) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a11ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4722c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6445ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -272.08,
    y1: 591.75,
    x2: -243.82,
    y2: 591.88,
    gradientTransform: "translate(-276.48 -511.99) rotate(-56.62)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 2809.85,
    cy: 1093.43,
    fx: 2809.85,
    fy: 1093.43,
    r: 62.07,
    gradientTransform: "translate(-595.45 -147.29) rotate(-.03) scale(.23 .17) skewX(.02)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 2883.23,
    cy: 1087.21,
    fx: 2883.23,
    fy: 1087.21,
    r: 62.07,
    gradientTransform: "translate(-619.86 -10.97) rotate(-11.74) scale(.23 .17) skewX(.02)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -1210.6,
    y1: 515.4,
    x2: -1192.12,
    y2: 500.17,
    gradientTransform: "translate(-1110.87 607.26) rotate(131.26) scale(1 -1)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 3.43,
    y1: 141.17,
    x2: 36.48,
    y2: 141.32,
    gradientTransform: "translate(19.15 -94.34) rotate(-11.71)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -3212.04,
    y1: -15.95,
    x2: -3172.72,
    y2: -15.95,
    gradientTransform: "translate(-1570.89 125.53) rotate(179.15) scale(.53 1) skewX(-.01)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -3193.51,
    y1: -13.7,
    x2: -3178.83,
    y2: -13.7,
    gradientTransform: "translate(-1570.89 125.53) rotate(179.15) scale(.53 1) skewX(-.01)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -74.47,
    y1: -305.26,
    x2: -74.47,
    y2: -324.16,
    gradientTransform: "translate(39.64 420.52) rotate(19.57)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -68.27,
    y1: -306.72,
    x2: -85.44,
    y2: -306.72,
    gradientTransform: "translate(39.64 420.52) rotate(19.57)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -88.01,
    y1: -294.04,
    x2: -88.01,
    y2: -319.49,
    gradientTransform: "translate(39.64 420.52) rotate(19.57)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -101.37,
    y1: -297.15,
    x2: -101.37,
    y2: -288.95,
    gradientTransform: "translate(39.64 420.52) rotate(19.57)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -102.29,
    y1: -291.48,
    x2: -86.92,
    y2: -291.48,
    gradientTransform: "translate(39.64 420.52) rotate(19.57)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -839.9,
    y1: -1065.56,
    x2: -839.9,
    y2: -1109.91,
    gradientTransform: "translate(-870.21 1069.2) rotate(105.46) scale(.83 .54) skewX(29.87)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -273.36,
    y1: -845.69,
    x2: -267.84,
    y2: -864.71,
    gradientTransform: "translate(-334.45 897.38) rotate(41.06)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -265.62,
    y1: -863.57,
    x2: -258.93,
    y2: -844.08,
    gradientTransform: "translate(-334.45 897.38) rotate(41.06)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -281.45,
    y1: -866.23,
    x2: -275.62,
    y2: -843.46,
    gradientTransform: "translate(-334.45 897.38) rotate(41.06)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -863.12,
    y1: -1070.99,
    x2: -863.12,
    y2: -1056.7,
    gradientTransform: "translate(-870.21 1069.2) rotate(105.46) scale(.83 .54) skewX(29.87)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -297.45,
    y1: -863.98,
    x2: -290.91,
    y2: -844.2,
    gradientTransform: "translate(-334.45 897.38) rotate(41.06)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -2329.75,
    y1: 617,
    x2: -2329.75,
    y2: 572.72,
    gradientTransform: "translate(-1440.78 -525.53) rotate(-148.22) scale(.83 .54) skewX(29.87)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -2353,
    y1: 611.6,
    x2: -2353,
    y2: 625.88,
    gradientTransform: "translate(-1440.78 -525.53) rotate(-148.22) scale(.83 .54) skewX(29.87)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -1305.15,
    y1: -859.74,
    x2: -1298.6,
    y2: -839.94,
    gradientTransform: "translate(-1425.65 37.01) rotate(147.38)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -2083.15,
    y1: 911.04,
    x2: -2083.15,
    y2: 880.33,
    gradientTransform: "translate(-1002.17 -678.93) rotate(-123.49) scale(.83 .54) skewX(29.87)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -1281.76,
    y1: -464.5,
    x2: -1277.94,
    y2: -477.67,
    gradientTransform: "translate(-1224.44 -161.84) rotate(172.11)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -1276.39,
    y1: -476.88,
    x2: -1271.75,
    y2: -463.36,
    gradientTransform: "translate(-1224.44 -161.84) rotate(172.11)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -1287.37,
    y1: -478.73,
    x2: -1283.33,
    y2: -462.95,
    gradientTransform: "translate(-1224.44 -161.84) rotate(172.11)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -34.89,
    y1: 702.93,
    x2: -41.66,
    y2: 703.03,
    gradientTransform: "translate(-282.15 -484.36) rotate(-38.26)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -1232.08,
    y1: 751.9,
    x2: -1235.39,
    y2: 751.95,
    gradientTransform: "translate(-648.46 -3359.67) rotate(-85.77) scale(2.72 1.33)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -516.57,
    y1: 1263.61,
    x2: -531.23,
    y2: 1263.82,
    gradientTransform: "translate(-776.83 -1006.42) rotate(-58.66)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -1446.42,
    y1: 898.73,
    x2: -1457.86,
    y2: 898.9,
    gradientTransform: "translate(-1636.41 59.85) rotate(-147.82)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -550.01,
    y1: 1062.07,
    x2: -561.45,
    y2: 1062.24,
    gradientTransform: "translate(-694.55 -801.01) rotate(-70.98)",
    xlinkHref: "#linear-gradient-16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "91.84 68.1 120.71 87.07 62.48 86.77 33.6 67.81 91.84 68.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "120.71 87.07 111.39 152 53.15 151.7 62.48 86.77 120.71 87.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "62.48 86.77 53.15 151.7 24.28 132.73 33.6 67.81 62.48 86.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m91.84,68.1s-1.18,7.74-2.85,18.81l31.73.16-28.87-18.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m91.84,68.1l-58.24-.3,28.87,18.97,58.24.3-28.87-18.97Zm-56.35.27l56.18.29,27.15,17.84-56.18-.29-27.15-17.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m83.82,118.14c-2.59,18.08-5.96,32.56-7.54,32.34-1.57-.22-.75-15.07,1.84-33.15,2.59-18.08,5.96-32.56,7.54-32.34s.75,15.07-1.84,33.15Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 94.51,
    cy: 119.1,
    rx: 32.52,
    ry: 2.88,
    transform: "translate(-36.79 195.78) rotate(-81.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m40.59,107.27c-2.46,17.21-5.74,30.97-7.31,30.75s-.85-14.35,1.61-31.56c2.46-17.21,5.74-30.97,7.31-30.75,1.57.22.85,14.35-1.61,31.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m49.68,111.64c-2.55,17.78-5.89,32.01-7.46,31.79-1.57-.22-.79-14.82,1.76-32.6s5.89-32.01,7.46-31.79.79,14.82-1.76,32.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "75.12 151.81 90.57 151.89 99.87 86.97 84.42 86.89 75.12 151.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "31.86 137.71 43.06 145.07 52.36 80.13 41.15 72.77 31.86 137.71"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-48",
    cx: 41.71,
    cy: 68.93,
    rx: 66.19,
    ry: 17.66
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "76.08 24.5 112.2 33.11 53.26 54.08 17.15 45.47 76.08 24.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "112.2 33.11 115.16 47.48 56.23 68.45 53.26 54.08 112.2 33.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "53.26 54.08 56.23 68.45 20.11 59.83 17.15 45.47 53.26 54.08"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m33.3,60.14c3.67,17.58,5.38,32.1,3.82,32.43-1.56.32-5.79-13.67-9.46-31.25-3.67-17.58-5.38-32.1-3.82-32.43,1.56-.32,5.79,13.67,9.46,31.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m44.83,59.02c3.67,17.58,5.38,32.1,3.82,32.43-1.56.32-5.79-13.67-9.46-31.25-3.67-17.58-5.38-32.1-3.82-32.43,1.56-.32,5.79,13.67,9.46,31.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m80.31,53.68c3.67,17.58,5.38,32.1,3.82,32.43-1.56.32-5.79-13.67-9.46-31.25-3.67-17.58-5.38-32.1-3.82-32.43,1.56-.32,5.79,13.67,9.46,31.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m93.45,50.44c3.67,17.58,5.38,32.1,3.82,32.43-1.56.32-5.79-13.67-9.46-31.25-3.67-17.58-5.38-32.1-3.82-32.43s5.79,13.67,9.46,31.25Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "30.39 62.28 43.43 65.4 40.43 51.02 27.39 47.91 30.39 62.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "77.86 60.75 92.41 55.57 89.42 41.22 74.86 46.4 77.86 60.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "55.94 31.67 41.44 36.82 74.86 46.4 89.42 41.22 55.94 31.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "84.31 26.46 27.39 47.91 31.72 48.94 40.43 51.02 97.38 29.58 84.31 26.46"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m91.46,7.08c-9.49-7.15-33.25,21.1-24.29,29.25l4.21,3.67c-7.11-15.7,17.91-34.13,24.29-29.25l-4.21-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m67.17,36.33c5.97,4.03,26.86-13.48,26.28-24.82-.1-1.86-.77-3.35-1.99-4.42l4.21,3.67c9.33,9.38-14.31,30.74-22.78,29.82-.58-.06-1.17-.29-1.51-.58l-4.21-3.67"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m76.42.23c-11.4-3.38-23.75,31.39-12.5,35.89l5.23,1.96C56.99,25.86,73.97-.15,81.65,2.19l-5.23-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m63.92,36.12c7,1.69,20.44-22.02,15.92-32.44-.74-1.71-1.89-2.87-3.41-3.45l5.23,1.96c12.02,5.53-2.63,33.8-10.89,35.9-.57.14-1.2.14-1.61-.01l-5.23-1.96"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.71,20.6c5.84-10.34,38.93,6.09,33.96,17.13l-2.4,5.04c.24-17.23-30.07-24.15-33.96-17.13l2.4-5.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m60.67,37.73c-3.86,6.07-30.02-1.65-34.02-12.28-.66-1.74-.64-3.38.06-4.85l-2.4,5.04c-4.8,12.32,25.41,22.48,32.81,18.26.51-.29.96-.73,1.15-1.13l2.4-5.04"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m36.55,8.56c9.15-7.58,34.2,19.53,25.63,28.08l-4.04,3.86c6.37-16.01-19.48-33.26-25.63-28.08l4.04-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m62.18,36.65c-5.77,4.3-27.46-12.22-27.41-23.57,0-1.86.61-3.38,1.78-4.51l-4.04,3.86c-8.88,9.81,15.73,30.04,24.15,28.73.58-.09,1.16-.34,1.48-.65l4.04-3.86"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-62",
    cx: 65.58,
    cy: 43.13,
    rx: 20.6,
    ry: 11.82,
    transform: "translate(-7.4 14.24) rotate(-11.74)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m45.69,24.67c2.73-3.3,21.06,10.02,18.6,13.62l-3.81,5.33c-3.43-6.56-18.81-13.42-18.35-13.98l3.56-4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m64.3,38.29c-2.72.22-20.66-10.72-18.6-13.62l-3.56,4.98c-2.48,4.07,14.98,15.34,17.87,14.3.2-.07.39-.2.48-.33l3.81-5.33"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m64.12,37.95c-3.4-2.61,9.3-21.36,13-19.03l5.47,3.61c-6.45,3.65-12.78,19.23-13.36,18.8l-5.11-3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m77.12,18.92c.31,2.71-10.02,20.98-13,19.03l5.11,3.38c4.16,2.34,14.84-15.48,13.7-18.33-.08-.2-.21-.38-.35-.47l-5.47-3.61"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 56.81,
    cy: 39.86,
    rx: 14.4,
    ry: 10.65,
    transform: "translate(-6.91 12.36) rotate(-11.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m87.36,32.42c1.2,5.76-4.14,11.73-11.93,13.35-7.79,1.62-15.07-1.73-16.27-7.49-1.2-5.76,4.14-11.73,11.93-13.35,7.79-1.62,15.07,1.73,16.27,7.49Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m53.53,38.97c.7-.77,19.76-4.39,20.53-4.06l3.86,3.76c-8.86-.8-26.58,5.44-26.25,4.75l1.85-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m74.07,34.91c-1.13,1.24-21.49,6.39-20.53,4.06l-1.85,4.45c-1.79,5.36,26.33-1.59,26.44-4.29,0-.16-.07-.34-.19-.46l-3.86-3.76"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m130.91,118.64c1.51-.29,2.47-1.09,2.5-2.09l-.03-2.65c-.05,1.21-1.32,1.87-2.5,2.09l.03,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m133.4,116.55c-.16-2.31-7.33-3.01-7.82-1.7,0,.02-.03.09-.03.18l-.03-2.65c.13-1.64,7.14-.68,7.77,1.07.05.14.08.31.08.45l.03,2.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m73.84,104.58c1.76-1.1,2.18-3.74,2.88-8.11l-3.4,1.92c-.68,4.25-1.13,7.05-2.88,8.11,1.13-.64,2.28-1.25,3.4-1.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m61.14,102.07c1.37-.68,3.05-.13,6.53,1.45,2.27,1.03,4.41,2,6.17,1.06-1.13.64-2.27,1.28-3.4,1.92-1.82.91-3.86-.01-6.02-.99-3.21-1.45-5.25-2.28-6.68-1.52,1.13-.64,2.25-1.31,3.4-1.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m59.41,105.32c.39-1.14,1.05-2.83,1.73-3.25-1.13.64-2.27,1.28-3.4,1.92-1.05.67-1.65,1.91-2.06,4.28,0,0-1.16,7.07-2.91,8.13,1.13-.64,2.28-1.25,3.4-1.92,1.43-.9,2.46-5.72,2.79-7.46.11-.56.26-1.13.45-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m41.4,116.3c.42-2.43,1.02-3.68,2.07-4.33-1.13.64-2.27,1.28-3.4,1.92-1.06.67-1.66,1.93-2.07,4.33l3.4-1.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m43.47,111.97c1.37-.68,3.05-.13,6.53,1.45,2.27,1.03,4.41,2,6.17,1.06-1.13.64-2.27,1.28-3.4,1.92-1.82.91-3.86-.01-6.02-.99-3.21-1.45-5.26-2.28-6.68-1.52,1.13-.64,2.25-1.31,3.4-1.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m15.74,63.7c1.37-.68,3.4-1.59,3.91-1.24-.78-.65-1.56-1.3-2.34-1.95-.81-.53-2.31.01-5.15,1.87,0,0-8.45,5.6-9.75,4.67.78.65,1.53,1.34,2.34,1.95,1.1.72,6.87-2.83,8.94-4.15.67-.43,1.35-.82,2.04-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m29.45,70.62c-.82-.53-2.32.02-5.19,1.91,0,0-8.43,5.62-9.73,4.69.78.65,1.53,1.34,2.34,1.95h0c1.24.82,4.03-.91,8.56-3.92,1.16-.77,2.38-1.45,3.66-2.02,1.14-.51,2.32-.92,2.7-.66-.78-.65-1.56-1.3-2.34-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.17,81.3c1.83-5.45,2.46-7.86,1.62-8.74-.74-.7-1.56-1.3-2.34-1.95.93.85-.02,3.96-1.7,8.98-1.13,3.37-2.2,6.56-1.08,7.71.78.65,1.56,1.3,2.34,1.95-1.16-1.05-.03-4.4,1.16-7.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m18.03,71.21c1.83-5.45,2.46-7.86,1.62-8.74-.74-.7-1.56-1.3-2.34-1.95.93.85-.02,3.96-1.7,8.98-1.13,3.37-2.2,6.56-1.08,7.71.78.65,1.56,1.3,2.34,1.95-1.16-1.05-.03-4.4,1.16-7.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m2.34,54.23c2.9-1.9,4.41-2.46,5.2-1.91-.78-.65-1.56-1.3-2.34-1.95-.82-.53-2.33.02-5.2,1.91l2.34,1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m5.92,61.06c1.83-5.45,2.46-7.86,1.62-8.74-.74-.7-1.56-1.3-2.34-1.95.93.85-.02,3.96-1.7,8.98-1.13,3.37-2.2,6.56-1.08,7.71.78.65,1.56,1.3,2.34,1.95-1.16-1.05-.03-4.4,1.16-7.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m122.49,60.61c.27,1.5.57,3.7.09,4.1.84-.57,1.69-1.13,2.53-1.7.74-.63.63-2.22-.36-5.46,0,0-3.01-9.68-1.75-10.65-.84.57-1.72,1.09-2.53,1.7-1,.85.79,7.38,1.48,9.74.22.77.41,1.53.54,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m135.35,50.43c1.01,3.32,1.12,4.92.38,5.52.84-.57,1.69-1.13,2.53-1.7.74-.64.63-2.24-.38-5.52l-2.53,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m127.79,51.94c4.72,3.28,6.87,4.56,7.94,4.01.88-.52,1.69-1.13,2.53-1.7-1.08.65-3.8-1.13-8.15-4.16-2.92-2.03-5.69-3.95-7.11-3.2-.84.57-1.69,1.13-2.53,1.7,1.33-.81,4.24,1.21,7.32,3.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m117.25,130.32c-.27,1.02-.72,2.5-1.13,2.61.7-.11,1.39-.22,2.09-.34.65-.18,1.04-1.21,1.36-3.54,0,0,.92-6.96,1.99-7.22-.7.11-1.4.19-2.09.34-.88.24-1.65,4.87-1.9,6.56-.08.55-.19,1.08-.32,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m107.39,134.33c.65-.19,1.05-1.22,1.37-3.58,0,0,.9-6.96,1.97-7.21-.7.11-1.4.19-2.09.34h0c-1,.28-1.36,2.52-1.85,6.25-.13.96-.33,1.91-.61,2.83-.26.83-.58,1.63-.88,1.71.7-.11,1.39-.22,2.09-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m101.47,129.84c2.02,3.43,3,4.86,3.84,4.83.7-.07,1.39-.22,2.09-.34-.87.1-2.06-1.82-3.92-4.98-1.25-2.13-2.43-4.13-3.55-4.07-.7.11-1.39.22-2.09.34,1.08-.12,2.32,1.99,3.63,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m112.28,128.1c2.02,3.43,3,4.86,3.84,4.83.7-.07,1.39-.22,2.09-.34-.87.1-2.06-1.82-3.92-4.98-1.25-2.13-2.43-4.13-3.55-4.07-.7.11-1.39.22-2.09.34,1.08-.12,2.32,1.99,3.63,4.23Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "115.99 89.21 125.1 97.55 125.5 92.21 115.99 89.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "100.29 64.52 108.45 62.48 106.22 57.47 100.29 64.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "33.71 97.49 29 103.11 23.06 104.69 31.07 95.61 33.71 97.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "70.49 69.97 78.11 74.76 77.12 76.32 68.57 72.58 70.49 69.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "130.64 69.2 127.7 77.7 125.96 77.1 127.66 67.93 130.64 69.2"
  })), /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 7,
    transform: "translate(87.41 71.35)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAA1UlEQVQImWLACRgYGAAAAAD//2IEEVvu/f9/6yYDw9kzDAzMLAwMf38xMCytZ2QEAAAA//9i3P3x//9f7yAqr95kYLhxlYHh5xcGBgYGBgYAAAAA//8EwaENACAMALAOshDEDPx/JmKOdgjW5TUxqUNu4AMAAP//YtmzmYFBRp6B4d5DBoaHjxgY/v5mYGD7z8DAxsDAAAAAAP//AtuZPPH//5//GBg+f2JgYPrHwMDMyMCwpoGREQAAAP//YgFJ/vgAMYYHYhHYMQwMDAwAAAAA//8DAB67K20CCegJAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 6,
    transform: "translate(138.41 83.35)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAvElEQVQImWIsX/7/v7UpA8OV6wwMr14xMLx+wsCwtJ6REQAAAP//Ylx96/9/DmYGhi/fGRiOHmVgeP+CgYGBgYEBAAAA//9iUlNmYJBXZGBgZmFg4ORhYODgY2BgYGBgAAAAAP//Ytl3mIHh5y8GhpevGRju3mdgYPzLwMDOyMAAAAAA//9iuXKegYGNm4Hh7QcGhr+/GBjYGBkYWJkYGAAAAAD//2IEaYtu/P8fYgAELK1nZAQAAAD//wMA7MMlQ4bpxlYAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 6,
    transform: "translate(3.41 90.35)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAvElEQVQImWJkYGBg6Nv2//+P3wwMDx8wMHz5wMCwtJ6REQAAAP//Ytz84v//OxcYGH79YWB48ICB4dM7BgaG/wwMAAAAAP//YmFkZmBwdGFguHuPgeHdJwaGX78ZGH7/YGAAAAAA//9iefecgeHHBwaG+48YGF68YWD48YOBgekvAwMAAAD//2I5eYyBgYmNgeH9RwaG9+8ZGNgYGRjYmRgYAAAAAP//Alse3fj/P4iGAwYGBgAAAAD//wMAD0Uwdh8RXOUAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 6,
    transform: "translate(121.41 28.35)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAACXBIWXMAAAsSAAALEgHS3X78AAAA1klEQVQImWJkYGBg6Nv+//+PXwwML18yMLx5zsCwtJ6RkYGBgQEAAAD//2JafO//fxCTmZmBQUCIgYGBkYEhpuX/fwYGBgYAAAAA//9iEeRlYNB1YWC4e4+B4eFjBgYOHogCBgYGBgAAAAD//2J5cIuB4YcYA8P9RwwMT58xMPz4x8Dw7wcDAwMDAwMAAAD//2K5eJqB4SYfA8P7jwwMnz8xMDD9Y2BgZ2JgYGBgYAAAAAD//2KaXcDI+PkdA8PvHwwMIBO5mBgYmEEyDAwMAAAAAP//AwBFtStKT7rXWQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 7,
    transform: "translate(7.41 38.35)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAA2UlEQVQImWJABtGN//+DMFiMgYEBAAAA//9iBBE7Hv3/v30rAwMDEwPD+3cMDH9/MzAsrWNkBAAAAP//Ytz+/v9/UQ4Ghq9fGRhOnmFguHGVgeHPLwaGv78YGAAAAAD//wTBsRUAEBAFsHze6TS3/xZKw5GMPKo4l0x2k4XwAQAA//9i2baGgYFflIHh7z8GhuNnIEYy/Gdg4GFgYAAAAAD//wLbmTzx////TAwMb98xMPz5y8DAxsjAsL6RkREAAAD//wJLwlwKYy+tZ2RkYGBgAAAAAP//AwBOkjRTO2/WawAAAABJRU5ErkJggg=="
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.c45cd8a0595c3a7297ec0742fcaf640b.svg";
export { ForwardRef as ReactComponent };